import React, { useCallback, useEffect } from 'react';
import { DataGrid, Column, HeaderFilter,
  Paging, SearchPanel, Export,
} from 'devextreme-react/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid as xlsExportDataGrid } from 'devextreme/excel_exporter';
import { groupBy } from '../../utils/miscUtil';

export default function HSEReportData(props) {

  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  useEffect(() => {
    let fd = Object.keys(groupBy(props.data, 'company_id'))
    let fd1 = Object.keys(groupBy(props.data, 'Identifier'))
    let randStruct = {}
    let randStructAvail = {}
    for (var i=0; i<fd1.length; i++) {
      randStructAvail[fd1[i]] = [...Array(fd.length).keys()]
    }

    for (i=0; i<props.data.length; i++) {
      if (!('company_name' in props.data[i])) {
        if (!(randStruct[props.data[i]["Identifier"]])) {
          randStruct[props.data[i]["Identifier"]] = {}
        }
        if (!(randStruct[props.data[i]["Identifier"]][props.data[i].company_id])) {
          var rnd_idx = getRandomInt(randStructAvail[props.data[i]["Identifier"]].length);
          var rnd_cnt = randStructAvail[props.data[i]["Identifier"]][rnd_idx]
          randStructAvail[props.data[i]["Identifier"]].splice(rnd_idx, 1)
          randStruct[props.data[i]["Identifier"]][props.data[i].company_id] = "Company "+rnd_cnt.toString()
        }
        props.data[i].company_name = randStruct[props.data[i]["Identifier"]][props.data[i].company_id]
      }
    }
  }, [props.data, props.year]);

  const onExporting = useCallback((e) => {
    if (e.format === "xlsx") {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Main sheet');

      xlsExportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'AXPC-HSE-Data.xlsx');
        });
      });
    }
  }, []);

  const formatCompanyName = (cellInfo) => {
    if (cellInfo.value) {
      return cellInfo.value;
    }
    return "Hidden Company Name";
  }

  return (
    <div>

      {props.data && <div className={'content-block'}>

        <DataGrid id="dataGrid"
          dataSource={props.data}
          columnHidingEnabled={true}
          cellHintEnabled={true}
          wordWrapEnabled={true}
          onExporting={onExporting}
        >
          <Export enabled={true} formats={['xlsx']} />
          <HeaderFilter visible={true} />
          <SearchPanel visible={true} width="300px"/>
          <Column
            dataField={'year'}
            caption={'Year'}
            defaultSortOrder="desc"
            visibleIndex={1}
            width="100px"
          >
          </Column>
          <Column
            dataField={'company_name'}
            caption={'Company'}
            visibleIndex={2}
            width="120px"
            customizeText={formatCompanyName}
          />
          <Column
            dataField={'Category'}
            caption={'Category'}
            visibleIndex={3}
            hidingPriority={2}
            width="120px"
          >
          </Column>
          <Column
            dataField={'Subcategory'}
            caption={'Subcategory'}
            visibleIndex={4}
            hidingPriority={1}
            width="140px"
          >
          </Column>
          <Column
            dataField={'Details'}
            caption={'Details'}
            visibleIndex={5}
            hidingPriority={3}
          >
          </Column>
          <Column
            dataField={'value'}
            caption={'Value'}
            visibleIndex={6}
            hidingPriority={4}
            width="140px"
          >
          </Column>


          <Paging defaultPageSize={100} />
        </DataGrid>
      </div>}

    </div>
  );
}
